module.exports = __webpack_public_path__ + "img/search.1432b0f6.svg";